<div
  class="inline-flex flex-col items-center gap-2.5"
  role="status"
  [attr.aria-label]="message()"
  [attr.aria-busy]="true"
>
  <span class="admin-spinner" aria-hidden="true">
    <span class="admin-spinner-bar"></span>
    <span class="admin-spinner-bar"></span>
    <span class="admin-spinner-bar"></span>
    <span class="admin-spinner-bar"></span>
    <span class="admin-spinner-bar"></span>
  </span>

  <span
    class="spinner-shimmer-text inline-block bg-clip-text text-sm text-transparent"
    aria-hidden="true"
  >
    {{ message() }}
  </span>

  <span class="sr-only">{{ message() }}</span>
</div>
